import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AuthHttpService} from '../core/auth-http.service';
import {environment} from '../../environments/environment';
import { catchError } from 'rxjs/operators';

export interface QuicksightReportsRole {
  id?: number;
  role_id: number;
  quicksight_report_id: number;
}

@Injectable()
export class QuicksightReportsRolesService {

  constructor(private http: AuthHttpService) {}

  list(params?: { role_id?: number; quicksight_report_id?: number }): Observable<any> {
    let url = `${environment.apiv3url}/quicksight_reports_roles`;
    const queryParams = [];

    if (params?.role_id) {
      queryParams.push(`role_id=${params.role_id}`);
    }
    if (params?.quicksight_report_id) {
      queryParams.push(`quicksight_report_id=${params.quicksight_report_id}`);
    }

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    return this.http.getV3(url).pipe(
      catchError((err) => this.http.handleError(err)));
  }

  create(data: QuicksightReportsRole): Observable<any> {
    return this.http.postV3(`${environment.apiv3url}/quicksight_reports_roles`, { quicksight_reports_role: data }).pipe(
      catchError((err) => this.http.handleError(err)));
  }

  update(id: number, data: QuicksightReportsRole): Observable<any> {
    return this.http.updateV3(`${environment.apiv3url}/quicksight_reports_roles/${id}`, { quicksight_reports_role: data }).pipe(
      catchError((err) => this.http.handleError(err)));
  }

  delete(id: number): Observable<any> {
    return this.http.deleteV3(`${environment.apiv3url}/quicksight_reports_roles/${id}`);
  }
}
